import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ScrollToTop from './ScrollToUp';
import Header from './components/Header/Header';
import Home from './pages/Home';
import Contact from './pages/Contact';
import AboutUs from './pages/AboutUs';
import Academics from './pages/Academics';

// Course Pages
import CoursePage from './pages/CoursePage';

// Academic Program Pages
import OurCourses from './pages/Academics/OurCourses';
import FoundationProgram from './pages/Academics/FoundationProgram';
import BusinessManagement from './pages/Academics/BusinessManagement';
import ComputingIT from './pages/Academics/ComputingIT';
import Law from './pages/Academics/Law';
import HealthSocialCare from './pages/Academics/HealthSocialCare';

// Academic Pages
import Undergraduate from './pages/Academics/Undergraduate';
import Graduate from './pages/Academics/Graduate';
import OnlineLearning from './pages/Academics/OnlineLearning';
import AcademicCalendar from './pages/Academics/AcademicCalendar';
import Departments from './pages/Academics/Departments';
import Research from './pages/Academics/Research';

// Admission Pages
import Admissions from './pages/Admissions';
import WhyChooseUs from './pages/Admissions/WhyChooseUs';
import HowToApply from './pages/Admissions/HowToApply';
import EntryRequirements from './pages/Admissions/EntryRequirements';
import TuitionFees from './pages/Admissions/TuitionFees';
import Scholarships from './pages/Admissions/Scholarships';
import InternationalStudents from './pages/Admissions/InternationalStudents';
import CampusTours from './pages/Admissions/CampusTours';
import FAQs from './pages/Admissions/FAQs';
import ContactAdmissions from './pages/Admissions/Contact';
import ApplyNow from './pages/Admissions/ApplyNow';

// Online Campus Pages
import AboutLawrenceOnline from './pages/OnlineCampus/AboutLawrenceOnline';
import WhyLawrenceOnline from './pages/OnlineCampus/WhyLawrenceOnline';
import SmartLearning from './pages/OnlineCampus/SmartLearning';
import OnlineVerification from './pages/OnlineCampus/OnlineVerification';
import Accreditation from './pages/OnlineCampus/Accreditation';
import UniversityProgression from './pages/UniversityProgression';
import Centers from './pages/Centers';
import Login from './pages/Auth/Login';
import Register from './pages/Auth/Register';
import Footer from './components/Footer/Footer';

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        <ScrollToTop />
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact" element={<Contact />} />
            
            {/* Academics Section with Nested Routes */}
            <Route path="/academics" element={<Academics />}>
              <Route index element={<OurCourses />} />
              <Route path="our-courses" element={<OurCourses />} />
              <Route path="foundation" element={<FoundationProgram />} />
              <Route path="business-management" element={<BusinessManagement />} />
              <Route path="computing-it" element={<ComputingIT />} />
              <Route path="law" element={<Law />} />
              <Route path="health-social-care" element={<HealthSocialCare />} />
              <Route path="tourism-hospitality" element={<CoursePage title="Tourism & Hospitality" />} />
              <Route path="short-courses" element={<CoursePage title="Short Courses" />} />
              
              {/* Additional academic sub-pages */}
              <Route path="undergraduate" element={<Undergraduate />} />
              <Route path="graduate" element={<Graduate />} />
              <Route path="online" element={<OnlineLearning />} />
              <Route path="calendar" element={<AcademicCalendar />} />
              <Route path="departments" element={<Departments />} />
              <Route path="research" element={<Research />} />
            </Route>
            
            {/* Legacy Course Routes (Kept for backward compatibility) */}
            <Route path="/courses/our-courses" element={<OurCourses />} />
            <Route path="/courses/foundation-programmes" element={<FoundationProgram />} />
            <Route path="/courses/business-management" element={<BusinessManagement />} />
            <Route path="/courses/computing-it" element={<ComputingIT />} />
            <Route path="/courses/law" element={<Law />} />
            <Route path="/courses/health-social-care" element={<HealthSocialCare />} />
            <Route path="/courses/tourism-hospitality" element={<CoursePage title="Tourism & Hospitality Management" />} />
            <Route path="/courses/short-courses" element={<CoursePage title="Short Courses" />} />

            {/* Admission Routes */}
            <Route path="/admissions" element={<Admissions />}>
              <Route index element={<WhyChooseUs />} />
              <Route path="why-choose-us" element={<WhyChooseUs />} />
              <Route path="how-to-apply" element={<HowToApply />} />
              <Route path="entry-requirements" element={<EntryRequirements />} />
              <Route path="tuition-fees" element={<TuitionFees />} />
              <Route path="scholarships" element={<Scholarships />} />
              <Route path="international" element={<InternationalStudents />} />
              <Route path="campus-tours" element={<CampusTours />} />
              <Route path="faqs" element={<FAQs />} />
              <Route path="contact" element={<ContactAdmissions />} />
              <Route path="apply-now" element={<ApplyNow />} />
              <Route path="apply" element={<Navigate to="apply-now" replace />} />
            </Route>
            
            {/* New Route */}
            <Route path="/apply-form" element={<ApplyNow />} />
            
            {/* Auth Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            
            {/* Online Campus Routes - Using Outlet for nested routes */}
            <Route path="/online-campus" element={<AboutLawrenceOnline />}>
              <Route index element={<Navigate to="about" replace />} />
              <Route path="about" element={<Navigate to="/online-campus" replace />} />
            </Route>
            <Route path="/online-campus/why-lawrence" element={<WhyLawrenceOnline />} />
            <Route path="/online-campus/smart-learning" element={<SmartLearning />} />
            <Route path="/online-campus/verification" element={<OnlineVerification />} />
            <Route path="/online-campus/accreditation" element={<Accreditation />} />
            
            {/* University Progression Route */}
            <Route path="/university-progression" element={<UniversityProgression />} />
            <Route path="/centers" element={<Centers />} />
            
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
